export enum EstimateSignatureEnum {
  PENDING = "PENDING",
  SIGNED = "SIGNED",
}

export enum EstimateStatusEnum {
  DRAFT = "DRAFT",
  APPROVED = "APPROVED",
  SENT = "SENT",
  DENIED = "DENIED",
  INVOICED = "INVOICED",
  VOID = "VOID",
}

export enum EstimateUoMEnum {
  DRAFT = "DRAFT",
  FINAL = "FINAL",
}

export const EstimateStatusOption = [
   { id: "DRAFT", label: "Draft" },
   { id: "APPROVED", label: "Approved" },
   { id: "SENT", label: "Sent" },
   { id: "DENIED", label: "Denied" },
   { id: "INVOICED", label: "Invoiced" },
   { id: "VOID", label: "Void" },
]

export const EstimateUoMOption = [
  { id: "BAG", label: "BAG" },
  { id: "BDL", label: "BDL" },
  { id: "BK", label: "BK" },
  { id: "BX", label: "BX" },
  { id: "CN", label: "CN" },
  { id: "CRT", label: "CRT" },
  { id: "GAL", label: "GAL" },
  { id: "HR", label: "HR" },
  { id: "items", label: "items" },
  { id: "PC", label: "PC" },
  { id: "PCT", label: "PCT" },
  { id: "POUCH", label: "POUCH" },
  { id: "RL", label: "RL" },
  { id: "SF", label: "SF" },
  { id: "SHT", label: "SHT" },
  { id: "SQ", label: "SQ" },
  { id: "SQFT", label: "SQFT" },
  { id: "EA", label: "EA" },
  { id: "LF", label: "LF" },
  { id: "Total", label: "Total" },
]

export enum EstimateLayoutEnum {
  COMMERCIAL_ESTIMATE_LAYOUT = "COMMERCIAL_ESTIMATE_LAYOUT",
}

export enum EstimateItemTypeEnum {
  MATERIAL = "MATERIAL",
  LABOR = "LABOR",
}

export const EstimateItemTypeOption = [
   { id: "MATERIAL", label: "MATERIAL" },
   { id: "LABOR", label: "LABOR" },
]


export enum CommercialEstimateStepEnum {
  STEP_1_TITLE = "STEP_1_TITLE",
  STEP_2_ABOUT_US = "STEP_2_ABOUT_US",
  STEP_3_INSPECTION = "STEP_3_INSPECTION",
  STEP_4_QUOTE_DETAILS = "STEP_4_QUOTE_DETAILS",
  STEP_5_AUTHORIZATION = "STEP_5_AUTHORIZATION",
  STEP_6_TERMS_CONDITIONS = "STEP_6_TERMS_CONDITIONS",
  STEP_7_CBR_INSURANCE = "STEP_7_CBR_INSURANCE",
}

export const EstimateModeViewEnum = {
  CREATE: "CREATE",
  VIEW: "VIEW",
  EDIT: "EDIT",
}

export const StyleInspectionEnum = {
  STANDARD: 0,
  SIDE_BY_SIDE: 1,
  WIDE: 2,
  FULL: 3,
} as const;

export const StyleInspectionOptions = [
  { id: StyleInspectionEnum.STANDARD, label: "Standard" },
  { id: StyleInspectionEnum.SIDE_BY_SIDE, label: "Side by Side" },
  { id: StyleInspectionEnum.WIDE, label: "Wide" },
  { id: StyleInspectionEnum.FULL, label: "Full" },
];
